import React from "react";
import StickyBar from "../StickyBar";
import HeaderExplore from "../HeaderExplore";
import PromotionalBanner from "../PromotionalBanner/PromotionalBanner";
import * as S from "./styles.js";

const Container = (props) => {
  return (
    <>
      <PromotionalBanner />
      <S.Wrapper>
        <HeaderExplore {...props} />
        {props.children}
      </S.Wrapper>
      <StickyBar />
    </>
  );
};

export default Container;
